<template>
 <div class="random-rewards-bind_success">
   <div class="random-rewards-bind_wrapper random-rewards-bind_wrapper__bound">
      <div class="random-rewards-bind_text">
        <h1
          class="heading1"
          v-html="$c('Поздравляем!<br /> Твоя карта Tanks Blitz привязана к акции «Миссия выполнима: Blitz-квест»!')"
        />
        <BoundCard />
      </div>
    </div>
    <div class="random-rewards-bind_form random-rewards-bind_form__bound">
      {{ $c('Тебе начислен %(spinBalance)s Шанс!', { spinBalance }) }}
    </div>
    <div class="random-rewards-bind_wrapper">
      <a @click="$root.$emit('closeRandomRewardsPopUp')" class="button contained">{{ $c('На страницу с заданиями') }}</a>
    </div>
 </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { TheMask } from 'vue-the-mask'
import BoundCard from './BoundCard'

import { namespace } from 'vuex-class'
const randomRewards = namespace('randomRewards')

@Component({
  components: {
    TheMask,
    BoundCard
  }
})
class BindCardSuccess extends Vue {
  @randomRewards.State('spinBalance') spinBalance
  @randomRewards.State('cardCodeHidden') cardCodeHidden
}

export default BindCardSuccess
</script>

<style lang="scss" scoped>
.random-rewards-bind_success {
  .button {
    width: 100%;
    box-sizing: border-box;
    @include media_desktop {
      width: auto;
    }
  }
}
</style>
